module.exports = __webpack_public_path__ + "static/media/templates.38bc4339.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/templates.png
// module id = 1119
// module chunks = 0